/**
 * Mobile Navigation Animation
 * 
 * @package crunchy
 */

(function($) {

	var $document = $( document );

	$document.ready(function() {

		// set vars
		var adminBar         = $( '#wpadminbar' );
		var header           = $( 'header[role=banner]' );
		var nav              = $( 'nav', header );
		var mobileToggler    = $( '#menu-toggle' );
		var primaryTopParent = $( '> ul > .menu-item-has-children', nav );
		var level2Menu       = $( '.level-2', nav );
		var level2MenuList   = $( 'ul', level2Menu );
		var level3Menu       = $( '.level-3', nav );
		var level3MenuList   = $( 'ul', level3Menu );
		var blankAnchors     = $( 'a[href="#"]', header );
		var childClass       = '.menu-item-has-children';
		var readerText       = '<span class="screen-reader-text">Menu</span>';
		var lastHoveredLevel1;


		// is it a section page?
		var isSectionPage = $( 'body' ).hasClass( 'section-page' );


		// pre-header layout
		var preHeader  = $( 'section + [role="banner"]' ).prev();
		if ( preHeader.length < 1 ) {
			preHeader = $( '.banner + [role="banner"]' ).prev();
		}


		// add submenu toggles & extra class
		// to "level 3" nested toggles
		$( '.menu ' + childClass, header ).append( '<button class="toggle-sub">' + readerText + '</button>' );
		$( '.sub-menu .toggle-sub', header ).addClass( 'toggle-level-3' );
		$( '.sub-menu ' + childClass + ' a', header ).addClass( 'toggle-level-3' );
		var subToggler = $( '.toggle-sub' );


		// set bindings
		mobileToggler.on( 'click', toggleMenu );
		subToggler.on( 'click', toggleSubmenu );
		$( 'a.toggle-level-3' ).on( 'click', toggleSubmenu );
		$( window ).resize( doMenuOffset );
		primaryTopParent.hover( openLevel2Menu, closeLevel2Menu );
		level2Menu.hover( persistLevel2Menu, unpersistLevel2Menu );
		blankAnchors.on( 'click', killDefault );


		
		/**
		 * Kill default click action
		 */
		function killDefault( e ) {
			e.preventDefault();
		}



		/**
		 * Toggle mobile menu
		 */
		function toggleMenu() {

			// is open, do close
			if ( mobileToggler.hasClass( 'toggled' ) ) {
				closeMobileMenu();
			} else {
				doPreHeaderScrollCheck();
				openMobileMenu();
			}
		}



		/**
		 * Open mobile menu
		 */
		function openMobileMenu( fixIt ) {

			// automatically fix if no preHeader
			fixIt = preHeader.length < 1 ? true : fixIt;

			// fix if section page
			if ( isSectionPage && fixIt ) {
				header.addClass( 'fixed' );
				$( '#content' ).addClass( 'header-fixed' );
			}

			// open menu
			mobileToggler.addClass( 'toggled' );
			nav.addClass( 'toggled' );

			// $( window ).bind( 'scroll', function() {} );
			// $( window ).bind( 'scroll', maybeUntoggleMobileMenu );
			disableScroll();

			doMenuOffset();
		}



		/**
		 * Close mobile menu
		 */
		function closeMobileMenu() {

			// unfix if section page
			if ( isSectionPage ) {
				header.removeClass( 'fixed' );
				$( '#content' ).removeClass( 'header-fixed' );
			}

			mobileToggler.removeClass( 'toggled' );
			nav.removeClass( 'toggled' );

			enableScroll();

			doMenuOffset();
		}

		/**
		 * Pre-header layout scroll check
		 */
		function doPreHeaderScrollCheck() {

			// if no preheader or we've scrolled past
			// it, bounce
			if ( ! preHeader || $document.scrollTop() >= preHeader.outerHeight( true ) ) {
				return;
			}

			// scroll to header, then open menu
			$( 'html, body' ).animate({
				scrollTop : header.offset().top + adminBar.outerHeight()
			}, 700, 'swing', function() {
				openMobileMenu( true );
			} );
		}


		/**
		 * Maybe untoggle the mobile menu via
		 * scroll if scrolled up to pre-header
		 */
		function maybeUntoggleMobileMenu() {

			if ( nav.hasClass( 'toggled' ) && $document.scrollTop() < preHeader.outerHeight( true ) ) {
				$( window ).unbind( 'scroll' );
				closeMobileMenu();
			}
		}



		/**
		 * Do menu offset
		 */
		function doMenuOffset() {

			if ( nav.hasClass( 'toggled' ) ) {
				nav.css({ top: getMenuOffset() });
			} else {
				nav.css({ top: -getMenuOffset() + -nav.outerHeight() });
			}
		}



		/**
		 * Calculate menu offset
		 */
		function getMenuOffset() {
			return header.outerHeight() + adminBar.outerHeight();
		}



		/**
		 * Toggle a submenu
		 */
		function toggleSubmenu() {

			// get parent
			var $this = $(this);
			var li = $this.parent();

			// are we opening or closing?
			if ( li.hasClass( 'sub-toggled' ) ) {
				closeSubmenu( li );
			} else {
				openSubmenu( li, $this.hasClass( 'toggle-level-3' ) );
			}
		}

		/**
		 * Open a submenu (by parent)
		 * 
		 * @param object  parent  the submenu's parent li
		 * @param bool    level3  if the selected toggle is for third-level menu
		 */
		function openSubmenu( parent, level3 ) {

			if ( ! level3 ) {
				closeSubmenus();
			}

			// get the submenu
			var submenu = $( '> .sub-menu', parent );

			// open the menu
			if ( level3 ) {
				openLevel3Menu( submenu );
			} else {
				parent.addClass( 'sub-toggled' );
				submenu.slideDown( 300 );
			}
		}

		/**
		 * Close a submenu (by parent)
		 *
		 * @param object  parent  the submenu's parent li
		 */
		function closeSubmenu( parent ) {
			parent.removeClass( 'sub-toggled' );
			$( '> .sub-menu', parent ).slideUp( 300 );
		}

		/**
		 * Close all open submenus
		 */
		function closeSubmenus() {
			var submenus = $( '.sub-toggled .sub-menu' );
			submenus.slideUp();
			$( '.sub-toggled' ).removeClass( 'sub-toggled' );
		}

		/**
		 * Toggle the level 3 submenu
		 * 
		 * @param object  submenu  the targeted submenu
		 */
		function openLevel3Menu( submenu ) {

			// reset the level 3 menu
			level3Menu.html( '<ul><li class="back"><a href="#"><i class="fa fa-long-arrow-left"></i>Back</a></li></ul>' );

			// add the new items
			$( 'ul', level3Menu ).append( submenu.children().clone() );

			// open it
			level3Menu.addClass( 'toggled' );

			// bind removing it
			level3Menu.hover( function() {
			}, function() {
				closeLevel3Menu( true );
			});

			// bind back button
			$( '.back a', level3Menu ).on( 'click', closeLevel3Menu );
		}		
		
		/**
		 * Close the level 3 menu
		 * 
		 * @param object  click event, if "back button"
		 * @param bool    closeLevel2
		 */
		function closeLevel3Menu( closeLevel2 ) {

			if ( closeLevel2 === true ) {
				level2Menu.removeClass( 'toggled' );
				level2Menu.removeClass( 'stay-open-for-3' );
				$( '.sub-menu-open' ).removeClass( 'sub-menu-open' );
			}

			level3Menu.removeClass( 'toggled' );
			$( '.level-3-open' ).addClass( 'sub-menu-open' );
			$( '.level-3-open' ).removeClass( 'level-3-open' );
		}


		/**
		 * Populate and open the desktop-only
		 * level 2 "mega" menu
		 */
		function openLevel2Menu() {

			// get the item's submenu children			
			var $this = $(this);
			var submenuItems = $( '> ul', $this ).children().clone();

			// flag the top-level item we're hovering
			lastHoveredLevel1 = $( '> a', $this );

			// add the menu contents
			level2MenuList.html( '' );
			level2MenuList.append( submenuItems );

			// bind the level-3 links
			$( '.toggle-level-3' ).on( 'click', function() {
				openLevel3Menu( $( '> .sub-menu', $(this).parent() ) );
				level2Menu.addClass( 'stay-open-for-3' );
				$( '.sub-menu-open' ).addClass( 'level-3-open' );
			});

			// show the menu
			level2Menu.addClass( 'toggled' );
		}

		/**
		 * Close the desktop-only level 2
		 * "mega" menu
		 */
		function closeLevel2Menu() {
			level2Menu.removeClass( 'toggled' );
		}

		/**
		 * Keep the level 2 menu open and "hover"
		 * the top-level menu item that opened
		 * it
		 */
		function persistLevel2Menu() {
			if (!level2MenuList.is(':empty'))
			{
				if (lastHoveredLevel1 != null)
					lastHoveredLevel1.addClass( 'sub-menu-open' );

				level2Menu.addClass( 'stay-open' );
				level2Menu.removeClass( 'stay-open-for-3' );
			}
		}

		/**
		 * Close the level 2 menu from being "kept
		 * open" and "un-hover" the link that 
		 * opened it
		 */
		function unpersistLevel2Menu() {
			if (!level2MenuList.is(':empty'))
			{
				if (lastHoveredLevel1 != null)
				lastHoveredLevel1.removeClass( 'sub-menu-open' );

				level2Menu.removeClass( 'stay-open' );
				level2MenuList.empty();
			}			
		}

		/* Credit To: https://stackoverflow.com/questions/4770025/how-to-disable-scrolling-temporarily?page=1&tab=votes#tab-top gblazex */
	
		// left: 37, up: 38, right: 39, down: 40,
		// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
		var keys = {37: 1, 38: 1, 39: 1, 40: 1};

		function preventDefault(e) {
			e.preventDefault();	
		}

		function preventDefaultForScrollKeys(e) {
			if (keys[e.keyCode]) {
				preventDefault(e);
				return false;
			}
		}

		// modern Chrome requires { passive: false } when adding event
		var supportsPassive = false;
		try {
			window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
				get: function () { supportsPassive = true; } 
			}));
		} 
		catch(e) 
		{

		}

		var wheelOpt = supportsPassive ? { passive: false } : false;
		var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

		// call this to Disable
		function disableScroll() {
			window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
			window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
			window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
			window.addEventListener('keydown', preventDefaultForScrollKeys, false);
		}

		// call this to Enable
		function enableScroll() {
			window.removeEventListener('DOMMouseScroll', preventDefault, false);
			window.removeEventListener(wheelEvent, preventDefault, wheelOpt); 
			window.removeEventListener('touchmove', preventDefault, wheelOpt);
			window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
		}

	}); // document.ready
})(jQuery);